import { render, staticRenderFns } from "./BusinessOnlyCard.vue?vue&type=template&id=017ca837&scoped=true&"
import script from "./BusinessOnlyCard.vue?vue&type=script&lang=js&"
export * from "./BusinessOnlyCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOnlyCard.vue?vue&type=style&index=0&id=017ca837&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ca837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VContainer,VRow,VSpacer})
